import React from "react";
import { useParams } from "react-router-dom";
import "./WorkSpaceDetails.scss";
import hexDiceLarge from '../assets/media/images/hexagon-dice-large.png'
import { workspaces } from "../constants/workspaces";
import { useNavigate } from "react-router-dom";

const WorkSpaceDetails = ({}) => {
    const { id } = useParams();
    const workspace = workspaces[id] || {};
    const navigate = useNavigate();

    const navigateToMainPage = () => {
        navigate('/workspaces');
    }
    return (
      <div className="workspaceDetailsWrapper">
        <div className="breadCrumbs">
          <span style={{ cursor: "pointer" }} onClick={navigateToMainPage}>
            Workspaces
          </span>{" "}
          {">"} <span style={{ opacity: 0.5 }}>Asset details</span>
        </div>
        <div className="header">
          <img src={hexDiceLarge} />
          <span style={{ fontSize: 20 }}>{workspace?.header}</span>
        </div>
        <div className="version">
          <span style={{ opacity: 0.5, marginRight: 8 }}>Version:</span>
          <span>{workspace?.version}</span>
        </div>
        {/* <div className="dates" style={{ display: "flex", gap: 16 }}>
          <div className="lastUpdated">
            <span style={{ opacity: 0.5, marginRight: 8 }}>Last updated:</span>
            <span>{workspace?.lastUpdated}</span>
          </div>
          <div className="publishedDate">
            <span style={{ opacity: 0.5, marginRight: 8 }}>
              Published date:
            </span>
            <span>{workspace?.published}</span>
          </div>
        </div> */}
        <div className="description">
          <div className="sectionHeader">Description</div>
          <div
            className="sectionContent"
            dangerouslySetInnerHTML={{ __html: workspace?.description }}
          ></div>
        </div>

        {workspace?.keyFeaturesOfCasper && (
          <div className="description">
            <div className="sectionHeader">Key Features of CASPER are</div>
            <div
              className="sectionContent"
              dangerouslySetInnerHTML={{ __html: workspace?.keyFeaturesOfCasper }}
            ></div>
          </div>
        )}
        {workspace?.nlpSearch && (
          <div className="savings">
            <div className="sectionHeader">NLP Search</div>
            <div
              className="sectionContent"
              dangerouslySetInnerHTML={{ __html: workspace?.nlpSearch }}
            ></div>
          </div>
        )}

        {workspace?.nlpSearchBenefits && (
          <div className="savings">
            <div className="sectionHeader">Benefits</div>
            <div
              className="sectionContent"
              dangerouslySetInnerHTML={{ __html: workspace?.nlpSearchBenefits }}
            ></div>
          </div>
        )}
        {workspace?.valueProp && (
          <div className="savings">
            <div className="sectionHeader">Value Proposition:</div>
            <div
              className="sectionContent"
              dangerouslySetInnerHTML={{ __html: workspace?.valueProp }}
            ></div>
          </div>
        )}
        {workspace?.recommendationEngine && (
          <div className="savings">
            <div className="sectionHeader">Recommendation Engine</div>
            <div
              className="sectionContent"
              dangerouslySetInnerHTML={{
                __html: workspace?.recommendationEngine,
              }}
            ></div>
          </div>
        )}
        { workspace?.benefits && (<div className="benefits">
          <div className="sectionHeader">Benefits</div>
          <div className="sectionContent">{workspace?.benefits}</div>
        </div>)}
        { workspace?.businessBenefits && (<div className="benefits">
          <div className="sectionHeader">Business Benefits:</div>
          <div
              className="sectionContent"
              dangerouslySetInnerHTML={{ __html: workspace?.businessBenefits }}
            ></div>
        </div>)}
        {workspace?.savings && (
          <div className="savings">
            <div className="sectionHeader">Savings</div>
            <div
              className="sectionContent"
              dangerouslySetInnerHTML={{ __html: workspace?.savings }}
            ></div>
          </div>
        )}

        <hr />

        <div className="footer">
          <div className="contactDetails">Contact Details:</div>
          <div className="createdBy">Created By</div>
          <div className="contactsWrapper">
            {workspace?.contact?.map((contact) => {
              return (
                <div className="contact">
                  <div>
                    <img src={contact.image} />
                  </div>
                  <div>
                    <div>{contact.name}</div>
                    <div>{contact.email}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
};

export default WorkSpaceDetails;
